<template>
  <section class="livratos-ia-section" ref="iaSection">
    <h2 class="section-title">Pourquoi choisir Livratos&nbsp;?</h2>
    <div
      class="ia-content mt-5 flex-column flex-lg-row d-flex align-items-center justify-content-between"
    >
      <!-- Illustration image -->
      <div class="ia-img text-center mb-4 mb-lg-0">
        <img
          src="@/assets/pictures/livraison-btp.webp"
          alt="Vue d’ensemble de la plateforme Livratos pour le BTP"
          class="img-fluid rounded shadow"
        />
        <p class="img-credit">Pensé pour les chantiers</p>
      </div>

      <!-- Texte -->
      <div class="ia-text ps-lg-5">
        <p>
          Livratos se positionne comme le maillon
          <strong>logistique dédié au BTP</strong>&nbsp;: une seule plateforme
          pour connecter <strong>fournisseurs</strong>,
          <strong>artisans</strong> et <strong>livreurs</strong>, suivre les
          courses, <strong>optimiser les chargements</strong> et sécuriser la
          facturation. Derrière l’interface, nous combinons algorithmes,
          contraintes réglementaires et retours terrain pour coller au quotidien
          réel des <strong>chantiers</strong>, pas à une vision théorique de la
          <strong>livraison</strong>.
        </p>
        <router-link
          to="/about"
          class="btn-cta-k2000 mt-3 fw-semibold text-uppercase"
        >
          En savoir plus
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "LivratosIaSection",
};
</script>

<style lang="scss" scoped>
.livratos-ia-section {
  padding: 80px 20px;
  max-width: 1200px;
  margin: 0 auto;
  background-color: $background;
}

.section-title {
  text-align: center;
  font-size: 2rem;
  font-weight: 700;
  color: $color-text;

  @media (min-width: 768px) {
    font-size: 2.5rem;
  }

  @media (min-width: 1200px) {
    font-size: 3rem;
  }
}

.ia-content {
  gap: 2rem;
}

.ia-img {
  flex: 1;
  max-width: 500px;

  img {
    max-width: 100%;
    border-radius: 12px;
    box-shadow: 0 0.2em 1.2em rgba(0, 0, 0, 0.1);
  }

  .img-credit {
    margin-top: 0.5rem;
    background-color: $color-darker;
    color: white;
    font-size: 0.75rem;
    padding: 4px 10px;
    border-radius: 8px;
    display: inline-block;
  }
}

.ia-text {
  flex: 1;
  color: $color-text;
  font-size: 1rem;

  p {
    font-size: 1.125rem;
    line-height: 1.7;
    color: $color-text-grey;
  }
}

.btn-cta-k2000 {
  position: relative;
  display: inline-block;
  padding: 0.8rem 1.9rem;
  font-size: 0.9rem;
  border-radius: 22px;
  background: #000;
  color: #fff;
  text-decoration: none;
  letter-spacing: 0.08em;
  text-align: center;
  border: 1px solid $color-primary;
  transition: all 0.22s ease-out;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.5),
    0 -2px 6px rgba(255, 255, 255, 0.03);

  &:hover {
    background: #050505;
    color: $color-primary;
    border-color: lighten($color-primary, 4%);
    box-shadow: 0 14px 26px rgba(0, 0, 0, 0.7),
      0 -2px 8px rgba(255, 255, 255, 0.05);
    transform: translateY(-1px);
  }

  &:active {
    background: #000;
    transform: translateY(1px);
    box-shadow: 0 6px 14px rgba(0, 0, 0, 0.6),
      0 -1px 4px rgba(255, 255, 255, 0.03);
  }
}
</style>
